import React, {useState} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import BanStatusCard from '../SharedComponents/BanStatuses/BanStatusCard';
import {useDebtPaymentBit} from '../DebtPaymentBitWrapper';
import {determineScreenTitle, determineImageName} from '../utils/banTypeClassifier';
import {banImageEnum} from '../Constants/debtPaymentEnum';
import Config from 'app/Config';
import Image from 'app/Components/Shared/Image/image';

const SelectPaymentBan = ({
  financialIssuesBans,
  noFinancialIssuesBans,
  displayConfig,
  bansList,
  epiData,
  isJetConnection,
  activeJetBan,
}) => {
  const {getPaymentStatusesForBan} = useDebtPaymentBit();
  const [isGroup2Expanded, setIsGroup2Expanded] = useState(false);

  const toggleGroup2 = () => {
    setIsGroup2Expanded(!isGroup2Expanded);
  };

  const getImageName = () => {
    if (determineImageName(bansList) === banImageEnum.BANS_WITH_DEBT_OR_PAYMENT_METHOD_ISSUE) {
      if (isMobile) {
        return epiData?.otherStatesImageMobile;
      } else {
        return epiData?.otherStatesImageDesktop;
      }
    } else {
      if (isMobile) {
        return epiData?.noDebtImageMobile;
      } else {
        return epiData?.noDebtImageDesktop;
      }
    }
  };

  return (
    <div className='select-payment-ban'>
      <div className='select-payment-ban__image'>
        <Image src={Config.epiBaseUrl + getImageName() || ''} alt='image' />
      </div>
      <div className={`select-payment-ban__title ${isMobile ? 'm-title ' : 'l-title '} bold`}>{epiData.generalTitle}</div>
      <div className={`select-payment-ban__sub_title ${isMobile ? 's-title ' : 'm-title '}`}>{determineScreenTitle(bansList, epiData)}</div>
      <div className='select-payment-ban__ban-list'>
        {/* Group 1: Financial Issues - Always displayed open */}
        {financialIssuesBans && financialIssuesBans.length > 0 && (
          <>
            {financialIssuesBans.map((ban, index) => (
              <BanStatusCard
                key={`financial-${index}`}
                banData={ban}
                getPaymentStatusesForBan={getPaymentStatusesForBan}
                isActiveJetBan={isJetConnection && activeJetBan == ban.banNumber}
              />
            ))}
          </>
        )}

        {/* Group 2: No Financial Issues - Collapsible only when both groups exist */}
        {noFinancialIssuesBans && noFinancialIssuesBans.length > 0 && (
          <>
            {displayConfig.shouldCollapseGroup2 ? (
              <>
                <div className='select-payment-ban__group-2-toggle' onClick={toggleGroup2}>
                  <span> {!isGroup2Expanded ? 'חשבונות נוספים' : 'הצג פחות '}</span>
                  <span className={`toggle-icon ${isGroup2Expanded ? 'expanded' : 'collapsed'}`}>
                    <Image className='toggle-icon__image' src={require('../images/down.svg')} alt='collapse' />
                  </span>
                </div>
                {isGroup2Expanded && (
                  <>
                    {noFinancialIssuesBans.map((ban, index) => (
                      <BanStatusCard
                        key={`no-financial-${index}`}
                        banData={ban}
                        getPaymentStatusesForBan={getPaymentStatusesForBan}
                        isActiveJetBan={isJetConnection && activeJetBan == ban.banNumber}
                      />
                    ))}
                  </>
                )}
              </>
            ) : (
              // Display open when only one group exists
              <>
                {noFinancialIssuesBans.map((ban, index) => (
                  <BanStatusCard
                    key={`no-financial-${index}`}
                    banData={ban}
                    getPaymentStatusesForBan={getPaymentStatusesForBan}
                    isActiveJetBan={isJetConnection && activeJetBan == ban.banNumber}
                  />
                ))}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const grouped = state.debtAndUpdatePayment.groupedBans;
  return {
    financialIssuesBans: grouped.FINANCIAL_ISSUES,
    noFinancialIssuesBans: grouped.NO_FINANCIAL_ISSUES,
    displayConfig: grouped.displayConfig,
    bansList: [...grouped.FINANCIAL_ISSUES, ...grouped.NO_FINANCIAL_ISSUES],
    epiData: state.debtAndUpdatePayment.epiData,
    isJetConnection: state.debtAndUpdatePayment.isJetConnection,
    activeJetBan: state.debtAndUpdatePayment.activeJetBan,
  };
};

export default connect(mapStateToProps)(SelectPaymentBan);
